/*
 * @Author: 赵泽文
 * @Date: 2022-03-07 16:36:38
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-07-18 13:53:07
 * @Description: 退货单数据存储
 */

import type {
  IInnerApplyOrderModel,
  IInnerApplyOrderStore,
} from '@monorepo/types/orders/innerApplyOrder/innerApplyOrder.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IInnerApplyOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
    order_state: '',
  },
  auditNo: '',
  auditProductList: [],
  total_money: '0',
  total_use_unit_qty: '0',
};

const innerApplyOrderStore: IInnerApplyOrderModel = {
  namespace: 'innerApplyOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default innerApplyOrderStore;
